<template>
    <div>
       <p class="green"><b>Datos de block Chain</b></p>
        <p class="grey">{{this.blockchain.data.documentName}}</p>
           <img class ='icons-document'
              :src="require('@/assets/icons/icon-document-grey.svg')"
              alt="bell icon"
            /> 
        <div class='mt-5'>
            <b>Registrado: </b> <p class = 'grey d-inline'> 18-09-2020 10:44</p>
        </div>
         <div class ='mt-2' >
            <b>HASH: </b> <p class = 'grey d-inline hash'>{{this.blockchain.hash}}</p>
        </div>
        <div class="mt-4">
          <button class="d-block pointer btn-grey" @click="atras()">Volver a lista de documentos</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DataBlockChain',
  computed: {
    ...mapGetters("container",{
      blockchain: 'blockchain',
    }),
  },
  mounted () {
    console.log(this.blockchain)
  },
  methods: {
    atras() {
      this.$parent.showDataBlockChain = false
    }
  }
}
</script>

<style lang= "scss" scoped>

.hash {
    word-wrap: break-word;
}

</style>
